import { Component, Inject, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { SignalrService } from "../../../services/signalr.service";
import { HttpService } from "../../../services/http.service";
import { HttpErrorsService } from "../../../services/http-errors.service";
import { ATP_DIALOG_DATA } from "../atp-dialog/atp-dialog.service";
import * as  $ from "jquery";
import autosize from "autosize"
import {AtpHttpService, IAtpUser} from "../../services/atp-http.service";

interface IMessage {
  id: number;
  chatId: number;
  chat: string;
  createdDate: Date;
  text: string;
  type: number;
  userId: number;
  user: string;
}


@Component({
  selector: 'app-atp-chat',
  templateUrl: './atp-chat.component.html',
  styleUrls: ['./atp-chat.component.scss']
})
export class AtpChatComponent implements OnInit, OnDestroy {

  form: FormGroup;
  messages: IMessage[] = [];
  userId: number;
  isSending: boolean;
  @ViewChild('messagesOut') messagesOut: ElementRef;
  constructor(
    private fb: FormBuilder,
    public signalr: SignalrService,
    private api: HttpService,
    private httpErrors: HttpErrorsService,
    @Inject(ATP_DIALOG_DATA) public chatId,
    private userApi: AtpHttpService<IAtpUser>
  ) {}

  ngOnInit(): void {
    this.userId = this.userApi.user.id;

    $(document).ready(function () {
      autosize(document.getElementsByClassName("atp-dynamic-form__textarea")[0]);
    });
    const formControls: any = {
      message: this.fb.control('', [Validators.required])
    };
    this.form = this.fb.group(formControls);

    this.signalr.chats.start('Init', this.chatId);

    this.signalr.chats.getEvent<any>('AddMessage').subscribe(
      (data: IMessage) => {
        this.messages.push(data);
        setTimeout( () => {
          this.messagesOut.nativeElement.scrollTop = this.messagesOut.nativeElement.scrollHeight;
        }, 1);
      }
    );

    this.api.getChatMessages<IMessage>(this.chatId).subscribe(
      (data) => {
        this.messages = data.reverse();
        setTimeout( () => {
          this.messagesOut.nativeElement.scrollTop = this.messagesOut.nativeElement.scrollHeight;
        }, 1);
      }
    );
  }

  submit() {
    if (!this.form.valid) {
      return;
    }

    if (this.isSending) {
      return;
    }

    this.isSending = true;
    this.signalr.chats.sendMessage('Send', this.chatId, this.form.value.message).then(
      (data) => {
        this.isSending = false;
        this.form.reset('');
      },
      (error) => {
        this.isSending = false;
        alert('Не удалось отправить сообщение!');
      }
    );
  }

  ngOnDestroy() {
    this.signalr.chats.unsubscribeAllEvents();
    this.signalr.chats.stop();
  }

  processingDate(dateString: string) {
    let date = new Date(dateString);
    return String(date.getDate()).padStart(2, '0') + '.' + String(date.getMonth() + 1).padStart(2, '0') + '.' + date.getFullYear();
  }

  processingTime(dateString: string) {
    const date = new Date(dateString);
    return String(String(date.getHours()).padStart(2, '0') + ':' + date.getMinutes()).padStart(2, '0');
  }
}
